const DATA = [
{ name: 'id', type: 'hidden', searchField: '', options:[], reference: '', nullable: true, editable: false, export: true, import: true },
{ name: 'name', type: 'textinput', nullable: false, editable: false, export: true, import: true },
{ name: 'name_rome', type: 'textinput', nullable: true, editable: false, export: true, import: true },
]

export default DATA;